<template>
  <v-container id="addChild" class="overview-container" fluid>
    <v-toolbar color="white" class="d-flex justify-center align-center elevation-2">
      <v-toolbar-title class="body-heading-large">Create Your Kid’s Easi Account</v-toolbar-title>
    </v-toolbar>
    <v-stepper v-model="currentStep" class="rounded-0 full-width">
      <v-stepper-header class="elevation-0">
        <template v-for="step in steps">
          <v-stepper-step :key="`${step.index}-step`" :complete="currentStep > step.index" :step="step.index" :editable="currentStep > step.index">
            {{ step.title }}
            <small>{{ step.subtitle }}</small>
          </v-stepper-step>

          <v-divider v-if="step.index < steps.length" :key="step.index" />
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <!-- General info form -->
        <v-stepper-content key="step-1-content" step="1">
          <v-card class="mb-12">
            <v-row>
              <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                <v-form :class="{ 'half-width': !isMobile }" v-model="isGeneralInfoFormValid" ref="generalInfoForm">
                  <!-- Name -->
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field label="First name" name="first-name" outlined dense type="text" required :rules="fistNameRules" v-model="firstName" />
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field label="Last name" name="last-name" outlined dense type="text" required :rules="lastNameRules" v-model="lastName" />
                    </v-col>
                  </v-row>

                  <!-- Birthday -->
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-menu ref="menu" v-model="isBirthdayPickerOpen" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="birthday" label="Birthday (optional)" outlined dense readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker ref="picker" v-model="birthday" :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" @change="selectBirthday"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-card>

          <v-btn color="secondary" @click="goToStep(2)" :disabled="!isGeneralInfoFormValid">
            Next
          </v-btn>

          <v-btn text @click="cancel">Cancel</v-btn>
        </v-stepper-content>

        <!-- Account info form -->
        <v-stepper-content key="step-2-content" step="2">
          <v-card class="mb-12">
            <v-row>
              <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                <v-form :class="{ 'half-width': !isMobile }" v-model="isAccountInfoFormValid" ref="accountInfoForm">
                  <v-text-field label="Child's email address" name="email" outlined dense type="text" required :rules="emailRules" v-model="email" />
                  <v-text-field label="Create a password" outlined dense :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" required :rules="passwordRules" v-model="password" @click:append="showPassword = !showPassword" />
                  <v-text-field label="Confirm password" outlined dense :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'" :type="showPasswordConfirmation ? 'text' : 'password'" required :rules="confirmPasswordRules" v-model="passwordConfirmation" @click:append="showPasswordConfirmation = !showPasswordConfirmation" />
                  <VuePhoneNumberInput v-model="phone" default-country-code="CA" :only-countries="['CA']" color="#354093" error-color="#ff4d4f" no-example :translations="phoneNumberPlaceHolder" />

                  <!-- TODO: add link for terms and condition and privacy policy -->
                  <v-checkbox v-model="isTermAndConditionAgreed" required :rules="termsRules">
                    <div slot="label">
                      I confirm that I am the child's parent or legal guardian, and I agree with the
                      <router-link :to="{ name: 'TermsOfServicePage' }">
                        Terms of Service
                      </router-link>
                      and
                      <router-link :to="{ name: 'PrivacyPolicyPage' }">
                        Privacy Policy
                      </router-link>
                    </div>
                  </v-checkbox>
                </v-form>
              </v-col>
            </v-row>
          </v-card>

          <v-btn color="secondary" @click="addKid" :disabled="!isAccountInfoFormValid">
            Create
          </v-btn>

          <v-btn text @click="cancel">Cancel</v-btn>
        </v-stepper-content>

        <!-- Result  -->
        <v-stepper-content key="step-3-content" step="3">
          <!-- TODO: move this to a seperated component -->
          <v-card v-if="isKidSuccessfullyAdded" class="py-12 px-4" flat>
            <v-theme-provider>
              <div class="text-center">
                <v-avatar color="success" size="70">
                  <v-icon large color="white">fas fa-check</v-icon>
                </v-avatar>
              </div>
            </v-theme-provider>

            <v-card-title class="justify-center text-center body-heading-large">
              Your child's account has been created
            </v-card-title>
            <v-card-subtitle class="d-flex text-center justify-center body-text-small">
              Your child will recived invitation within few mins.
            </v-card-subtitle>
            <v-card-text class="d-flex justify-center">
              <v-row>
                <v-col cols="12" md="12" class="d-flex justify-center">
                  <v-btn color="secondary" :to="{ name: 'CreateMission', params: { id: this.kidId } }">Create Quest Now!</v-btn>
                </v-col>
                <v-col cols="12" md="12" class="d-flex justify-center">
                  <v-btn color="secondary" outlined :to="{ name: 'ParentDashboard' }">Visit Parent Dashboard</v-btn>
                </v-col>
                <v-col cols="12" md="12" class="d-flex justify-center">
                  <v-btn color="secondary" outlined @click="addAnother">Add Another Child</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card v-else class=" py-12 px-4" flat>
            <v-theme-provider>
              <div class="text-center">
                <v-avatar color="error" size="70">
                  <v-icon color="white" large>fas fa-times</v-icon>
                </v-avatar>
              </div>
            </v-theme-provider>

            <v-card-title class="justify-center text-center body-heading-large">
              Oops. Your child's account was not created. Please try again.
            </v-card-title>
            <v-card-text class="d-flex justify-center">
              <v-row>
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-end">
                  <v-btn @click="cancel" color="secondary" outlined class="modal-btn">Cancel</v-btn>
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-start">
                  <v-btn @click="tryAgain" color="secondary" class="modal-btn">Try again</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>
<script>
  import VuePhoneNumberInput from "vue-phone-number-input";

  export default {
    name: "addChild",
    data() {
      return {
        phoneNumberPlaceHolder: {
          phoneNumberLabel: "Phone number (optional)",
        },
        showPassword: false,
        showPasswordConfirmation: false,
        currentStep: 1,
        steps: [
          {
            index: 1,
            title: "General",
            subtitle: "Please tell us about your child",
          },
          {
            index: 2,
            title: "Account & Password",
            subtitle: "Create an account for your kid",
          },
          {
            index: 3,
            title: "Compelete",
            subtitle: "",
          },
        ],
        kidId: "",
        email: "",
        password: "",
        passwordConfirmation: "",
        phone: "",
        firstName: "",
        lastName: "",
        birthday: "",
        isBirthdayPickerOpen: false,
        isTermAndConditionAgreed: false,
        isKidSuccessfullyAdded: false,
        fistNameRules: [(v) => !!v || "First name is required"],
        lastNameRules: [(v) => !!v || "Last name is required"],
        phoneRules: [(v) => !!v || "Phone number is required", (v) => (v && v.length >= 10) || "Phone number must be at least 10 numbers"],
        emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
        passwordRules: [(v) => !!v || "Password is required"],
        confirmPasswordRules: [(v) => !!v || "Password is required", (v) => v === this.password || "Password do not match"],
        termsRules: [(v) => !!v || "You must agree to continue"],
        birthdayRules: [(v) => !!v || "Birthday is required"],
        isGeneralInfoFormValid: false,
        isAccountInfoFormValid: false,
      };
    },
    watch: {
      isBirthdayPickerOpen(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      },
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },

      kids() {
        return this.$store.getters.getKids;
      },

      //Check if the kid already existed, email is used as identifier.
      isKidExisted() {
        if (this.kids.find((kid) => kid.email === this.email)) {
          return true;
        } else {
          return false;
        }
      },
    },

    components: { VuePhoneNumberInput },

    methods: {
      reset() {
        this.currentStep = 1;
        this.kidId = "";
        this.email = "";
        this.password = "";
        this.passwordConfirmation = "";
        this.phone = "";
        this.firstName = "";
        this.lastName = "";
        this.birthday = "";
        this.isBirthdayPickerOpen = false;
        this.isTermAndConditionAgreed = false;
        this.isGeneralInfoFormValid = false;
        this.isAccountInfoFormValid = false;
        this.$refs.generalInfoForm.resetValidation();
        this.$refs.accountInfoForm.resetValidation();
      },

      addKid() {
        this.$store.commit("setLoadingStatus", true);

        //If kid already existed, reactivate kid account; otherwise create new kid account.
        if (this.isKidExisted) {
          let kidId = this.kids.find((kid) => kid.email === this.email).id;

          this.$http
            .put(`/children/${kidId}/reactivate`)
            .then((response) => this.addKidSuccess(response))
            .catch((error) => this.addKidFail(error));
        } else {
          this.$http
            .post("/children", {
              email: this.email,
              password: this.password,
              password_confirmation: this.passwordConfirmation,
              phone: this.phone,
              first_name: this.firstName,
              last_name: this.lastName,
              birthday: this.birthday,
              is_term_and_condition_agreed: this.isTermAndConditionAgreed,
            })
            .then((response) => this.addKidSuccess(response))
            .catch((error) => this.addKidFail(error));
        }
      },

      addKidSuccess(response) {
        let kidId;

        if (response.data && response.data.id) {
          kidId = response.data.id;
        } else {
          kidId = undefined;
        }
        this.isKidSuccessfullyAdded = true;
        this.kidId = kidId;
        this.$store.commit("setLoadingStatus", false);
        this.goToStep(3);
      },

      addKidFail(error) {
        console.error(error);
        this.isKidSuccessfullyAdded = false;
        this.$store.commit("setLoadingStatus", false);
        this.goToStep(3);
      },

      selectBirthday(date) {
        this.$refs.menu.save(date);
      },

      goToStep(index) {
        if (index <= this.steps.length) {
          this.currentStep = index;
        }
      },

      cancel() {
        this.$router.go(-1);
      },

      tryAgain() {
        this.goToStep(1);
      },

      addAnother() {
        this.reset();
        this.goToStep(1);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ParentDashboard/AddChild.vue